import { render, staticRenderFns } from "./ProjectAccessRequestForm.vue?vue&type=template&id=5c213152&"
import script from "./ProjectAccessRequestForm.vue?vue&type=script&lang=js&"
export * from "./ProjectAccessRequestForm.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAccessRequestForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports